module.exports = __webpack_public_path__ + "img/clock.0e97b753.svg";